import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MoviesService } from '../../core/services/movies.service';
import { MovieModel } from 'src/app/core/interfaces/movie.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
})
export class SearchComponent implements OnInit {
  nameMovie = '';
  movies: MovieModel[] = [];
  loading: boolean = false;
  private searchSub?: Subscription;

  constructor(private activatedRoute: ActivatedRoute, private moviesService: MoviesService, private router: Router) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      this.nameMovie = params.text;

      this.searchMovies();

      //MANERA VIEJA
      // this.loading = true;
      // if (this.nameMovie && this.nameMovie.length > 2) {
      //   this.moviesService.searchMovies(this.nameMovie).subscribe((resp: any) => {
      //     this.movies = resp;
      //     this.loading = false;
      //   });
      // }
    });
  }

  searchMovies() {
    if (this.nameMovie && this.nameMovie.length > 2) {
      if (this.searchSub) {
        this.searchSub.unsubscribe();
      }

      this.loading = true;
      this.searchSub = this.moviesService.searchMovies(this.nameMovie).subscribe(resp => {
        this.movies = resp;
        this.loading = false;
      });
    }
  }

  goMovie(idMovie) {
    this.router.navigate(['/movie', idMovie]);
  }
}
